/**
 * Main Layout Component
 * Includes sidebar, header, content area, and footer
 */

import { ReactNode, useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Clock } from 'lucide-react';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onRefresh?: () => void;
}

export function Layout({
  children,
  title,
  searchValue,
  onSearchChange,
  onRefresh,
}: LayoutProps) {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 flex flex-col overflow-hidden">
        <Header
          title={title}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          onRefresh={onRefresh}
        />
        <div className="flex-1 overflow-auto">
          {children}
        </div>
        {/* Footer */}
        <footer className="h-8 bg-white border-t border-gray-200 flex items-center justify-between px-6 text-xs text-gray-500">
          <span>© Roket4Solutions, LDA</span>
          <div className="flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5" />
            <span>{formatTime(currentTime)}</span>
          </div>
        </footer>
      </main>
    </div>
  );
}
